import { Link } from "react-router-dom";
import { ShieldCheck, Clock, UserCheck, Handshake } from "lucide-react";

const points = [
  {
    icon: ShieldCheck,
    title: "Kvalitetssikret personale",
    description:
      "Alle vikarer er verificerede med gyldige autorisationer og erfaring fra den kommunale plejesektor.",
  },
  {
    icon: Clock,
    title: "Akutte og planlagte behov",
    description: "Vi dækker både akutte vagter og langsigtet bemanding til plejehjem, hjemmepleje og bosteder.",
  },
  {
    icon: Handshake,
    title: "Langsigtede samarbejder",
    description: "Vi tror på faste relationer. Jeres borgere fortjener genkendelighed og kontinuitet i plejen.",
  },
  {
    icon: UserCheck,
    title: "Dedikeret kontaktperson",
    description: "En fast kontaktperson der kender jeres institution og sikrer den rette bemanding.",
  },
];

export default function ForInstitutioner() {
  return (
    <section id="inst" className="section py-10 sm:py-14 md:py-18 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="kicker">For institutioner</span>
          <h2 className="section-title mt-2">Stabil og ansvarlig vikardækning</h2>
          <p className="section-subtitle">
            Vi forstår hverdagen på plejehjem, i hjemmeplejen og på bosteder.
            Derfor leverer vi ikke bare vikarer – vi leverer tryghed.
          </p>
        </div>

        <div className="mt-10 grid sm:grid-cols-2 gap-5">
          {points.map((p) => (
            <div key={p.title} className="card p-5 flex gap-4">
              <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center shrink-0">
                <p.icon className="text-accent-600" size={20} />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 text-sm">
                  {p.title}
                </h3>
                <p className="mt-1 text-sm text-slate-500 leading-relaxed">
                  {p.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <a href="#kontakt" className="btn btn-secondary btn-lg">
            Tal med os om jeres behov
          </a>
          <Link to="/for-institutioner" className="btn btn-ghost btn-lg">
            Læs mere
          </Link>
        </div>
      </div>
    </section>
  );
}
